import React, { useState } from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import { ICreatorFAQ } from "./ICreatorFAQ";
import commonStyles from "../commonStyles.module.scss";
import styles from "./faq.module.scss";

const CreatorFAQ = ({ hideComponent, faqs }: ICreatorFAQ.IProps) => {
    const [faqsOpen, setFaqsOpen] = useState<string[]>([]); // If a certain FAQ is open

    if (hideComponent) return null;

    const handleFaqClick = (faqId: string): void => {
        setFaqsOpen(
            faqsOpen.includes(faqId)
                ? faqsOpen.filter(f => f !== faqId)
                : [...faqsOpen, faqId]
        );
    };

    return (
        <div
            className={classNames(commonStyles.detailsSection, styles.resetEms)}
        >
            <div className={commonStyles.detailsSectionTitle}>FAQs</div>
            <div className={commonStyles.detailsSectionBody}>
                {faqs.map(faq => (
                    <div key={faq.uuid}>
                        <div
                            className={styles.question}
                            onClick={() => handleFaqClick(faq.uuid)}
                        >
                            <div className={styles.questionText}>
                                {faq.question}
                            </div>
                            <div
                                className={classNames(
                                    styles.faqClose,
                                    faqsOpen.includes(faq.uuid) &&
                                        styles.faqOpen
                                )}
                            >
                                &#10006;
                            </div>
                        </div>
                        <div
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                                __html: faq.answer,
                            }}
                            className={classNames(
                                styles.answer,
                                faqsOpen.includes(faq.uuid) && styles.answerOpen
                            )}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};
export default CreatorFAQ;
